import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import {
  createNewUserReducer,
  deleteUserReducer,
  getDetailUserReducer,
  getProfileUserReducer,
  updateLastLoginUserReducer,
  updatePasswordUserReducer,
  updateProfileUserReducer,
  updateUserReducer,
  userLoginReducer,
  usersListEmployeReducer,
  usersListReducer,
  usersListStoresUserReducer,
} from "./reducers/userReducers";
import {
  createNewOrganizerReducer,
  deleteOrganizerReducer,
  detailOrganizerReducer,
  getListOrganizerReducer,
  getListUserOrganizerReducer,
  updateOrganizerReducer,
} from "./reducers/organizerReducres";
import {
  deleteOrderReducer,
  getDetailOrderReducer,
  getListOrderReducer,
  updateOrderDriverReducer,
} from "./reducers/orderReducers";
import { getListTicketReducer } from "./reducers/ticketReducers";
import {
  createNewCategoryReducer,
  deleteCategoryReducer,
  detailCategoryReducer,
  getListCategoriesReducer,
  updateCategoryReducer,
} from "./reducers/categpryReducers";
import {
  getDashboardInfoReducer,
  getDashboardOrderStatsReducer,
} from "./reducers/dashboardReducers";
import {
  createNewBannerReducer,
  deleteBannerReducer,
  getListBannersReducer,
} from "./reducers/bannerReducers";
import {
  createNewStoreReducer,
  deleteStoreReducer,
  detailStoreReducer,
  getListStoresReducer,
  getListTimesStoreReducer,
  updateStoreReducer,
  updateStoreTimesReducer,
} from "./reducers/storeReducers";
import {
  deleteClientReducer,
  getListClientsReducer,
} from "./reducers/clientReducers";
import {
  createNewDriverReducer,
  deleteDriverReducer,
  detailDriverReducer,
  getListDriversReducer,
  updateDriverReducer,
} from "./reducers/driverReducers";
import {
  createNewSectionReducer,
  deleteSectionReducer,
  getListSectionByStoreReducer,
  getListSectionReducer,
} from "./reducers/sectionReducers";
import {
  createNewExtraItemReducer,
  createNewExtraReducer,
  createNewProductReducer,
  deleteExtraItemReducer,
  deleteExtraReducer,
  deleteProductReducer,
  detailProductReducer,
  getListProductReducer,
  listExtraProductReducer,
  updateProductReducer,
} from "./reducers/productReducers";
import {
  getListNotificationsReducer,
  markNotificationAsReadReducer,
  markAllNotificationsAsReadReducer,
  getListUnreadNotificationsReducer
} from "./reducers/notificationReducers";

const reducer = combineReducers({
  userLogin: userLoginReducer,

  // banners
  getListBanners: getListBannersReducer,
  createNewBanner: createNewBannerReducer,
  deleteBanner: deleteBannerReducer,

  // stores
  getListStores: getListStoresReducer,
  createNewStore: createNewStoreReducer,
  detailStore: detailStoreReducer,
  updateStore: updateStoreReducer,
  deleteStore: deleteStoreReducer,

  // clients
  getListClients: getListClientsReducer,
  deleteClient: deleteClientReducer,

  // drivers
  getListDrivers: getListDriversReducer,
  deleteDriver: deleteDriverReducer,
  createNewDriver: createNewDriverReducer,
  detailDriver: detailDriverReducer,
  updateDriver: updateDriverReducer,

  //
  usersList: usersListReducer,
  createNewUser: createNewUserReducer,
  getProfileUser: getProfileUserReducer,
  updateProfileUser: updateProfileUserReducer,
  deleteUser: deleteUserReducer,
  updatePasswordUser: updatePasswordUserReducer,
  updateLastLoginUser: updateLastLoginUserReducer,
  getDetailUser: getDetailUserReducer,
  updateUser: updateUserReducer,
  // stores users
  usersListStoresUser: usersListStoresUserReducer,
  getListTimesStore: getListTimesStoreReducer,
  updateStoreTimes: updateStoreTimesReducer,
  // employes
  usersListEmploye: usersListEmployeReducer,

  // organizers
  getListOrganizerReducer: getListOrganizerReducer,
  getListUserOrganizer: getListUserOrganizerReducer,
  createNewOrganizer: createNewOrganizerReducer,
  detailOrganizer: detailOrganizerReducer,
  updateOrganizer: updateOrganizerReducer,
  deleteOrganizer: deleteOrganizerReducer,

  // order
  getListOrder: getListOrderReducer,
  getDetailOrder: getDetailOrderReducer,
  deleteOrder: deleteOrderReducer,
  updateOrderDriver: updateOrderDriverReducer,
  // section
  getListSection: getListSectionReducer,
  createNewSection: createNewSectionReducer,
  deleteSection: deleteSectionReducer,
  getListSectionByStore: getListSectionByStoreReducer,
  // products
  getListProduct: getListProductReducer,
  deleteProduct: deleteProductReducer,
  createNewProduct: createNewProductReducer,
  detailProduct: detailProductReducer,
  updateProduct: updateProductReducer,
  listExtraProduct: listExtraProductReducer,
  deleteExtra: deleteExtraReducer,
  createNewExtra: createNewExtraReducer,
  createNewExtraItem: createNewExtraItemReducer,
  deleteExtraItem: deleteExtraItemReducer,

  // tickets
  getListTicket: getListTicketReducer,

  // categories
  getListCategories: getListCategoriesReducer,
  createNewCategory: createNewCategoryReducer,
  detailCategory: detailCategoryReducer,
  updateCategory: updateCategoryReducer,
  deleteCategory: deleteCategoryReducer,
  // dash
  getDashboardInfo: getDashboardInfoReducer,
  getDashboardOrderStats: getDashboardOrderStatsReducer,

  // notifications
  getListNotifications: getListNotificationsReducer,
  markNotificationAsRead: markNotificationAsReadReducer,
  markAllNotificationsAsRead: markAllNotificationsAsReadReducer,
  getListUnreadNotifications:getListUnreadNotificationsReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfoExpressHalalAdmin")
  ? JSON.parse(localStorage.getItem("userInfoExpressHalalAdmin"))
  : null;

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  applyMiddleware(...middleware)
);

export default store;
